import { Avatar, Checkbox } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseSharp } from "react-icons/io5";
import { useSelector } from "react-redux";
import { Button, Col, Input, Modal, ModalBody, Row, Spinner, Table } from "reactstrap";
import {
  trackUpsShipmentApi,
  trackUspsShipmentApi,
} from "../../api/TrackingApi";
import {
  createFedexLabelApi,
  createFedexReturnLabelApi,
  createUpsLabelApi,
  createUPSReturnLabelApi,
  createUspsLabelApi,
  getQuotesApi,
} from "../../api/getFedexQuotesApi";
import { upsServiceTypes } from "../../data";
import {
  saveData,
  uniqueID,
  uploadBase64Labels
} from "../../firebase/utility";
import Carrier from "../carriers/Carrier";
import FormInput from "../formInput/FormInput";
import SelectServiceCarrierModal from "./SelectServiceCarrierModal";
const AddShippingModal = ({
  modal,
  toggle,
  items,
  shippingData,
  orderData,
  returnOrder,
  customer_acc,
  refreshSaleOrderDetails,
}) => {
  const { user } = useSelector((state) => state.auth);
  const [shipping, setShipping] = useState(false);
  const { all_products } = useSelector((state) => state.products);
  const [selectedRows, setSelectedRows] = useState([]);

  const [lineItems, setLineItems] = useState(items ?? []);
  useEffect(() => {
    setLineItems(items ? JSON.parse(JSON.stringify(items)) : []);
  }, [items]);
  const [carrierModal, setCarrierModal] = useState(false);
  const [lbs, setLbs] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [length, setLength] = useState("");
  const [residential, setResidiential] = useState(false);
  const [insured, setInsured] = useState(false);
  const [account, setAccount] = useState(customer_acc ?? "");
  const [shippingCost, setShippingCost] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [signatureRequired, setSignatureRequired] = useState(false);
  const [carrier, setCarrier] = useState("FEDEX");
  const [servicesData, setServicesData] = useState([]);
  const [upsDropdownData, setUpsDropdownData] = useState([]);
  const [uspsDropdownData, setUspsDropdownData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [labelLoading, setLabelLoading] = useState(false);
  const [serviceType, setServiceType] = useState("");
  const [serviceCode, setServiceCode] = useState("");
  const [packageType, setPackageType] = useState("");
  const [oz, setOz] = useState("");
  const [quotesResponse, setQuotesResponse] = useState("");
  const toggleModal = () => setCarrierModal((prev) => !prev);
  const handleCheckboxChange = (event, row) => {
    if (event.target.checked) {
      setSelectedRows((prevSelected) => [...prevSelected, row]);
    } else {
      setSelectedRows((prevSelected) =>
        prevSelected.filter((item) => item.sku !== row.sku)
      );
    }
  };
  const handleSelectAll = (event, data) => {
    if (event.target.checked) {
      setSelectedRows(data);
    } else {
      setSelectedRows([]);
    }
  };
  const handleQuantityChange = (e, sku) => {
    const newQuantity = parseFloat(e.target.value);

    setSelectedRows((prevItems) => {
      const updatedItems = prevItems.map((item) =>
        item.sku === sku ? { ...item, quantity: newQuantity } : item
      );
      return updatedItems;
    });
  };
  useEffect(() => {
    setOz(lbs * 16);
  }, [lbs]);
  useEffect(() => {
    setLbs(oz / 16);
  }, [oz]);
  useEffect(() => {
    const filteredProducts = all_products?.filter((product) =>
      selectedRows.includes(product.sku)
    );
    let totalWeight = 0;
    filteredProducts?.forEach((product) => {
      const lineItem = lineItems.find((item) => item.sku === product.sku);
      if (product.weight && lineItem) {
        totalWeight += parseFloat(product.weight) * lineItem.quantity;
      }
    });
    setLbs(totalWeight);
  }, [selectedRows, lineItems]);
  const onPressCalculate = async () => {
    setLoading(true);

    if (!selectedRows?.length > 0) {
      toast.error("Please select any Item to proceed !");
      setLoading(false);
      return;
    }
    if (!lbs || !height || !length || !width) {
      toast.error("Please Select Dimensions to Proceed !");
      setLoading(false);
      return;
    }
    const data = {
      order: {
        billing: orderData?.billing,
        shipping: orderData?.shipping,
      },
      totalDimensions: {
        totalWeight: lbs.toString(),
        totalHeight: height,
        totalLength: length,
        totalWidth: width,
      },
    };
    try {
      getQuotesApi(data, (res) => {
        setQuotesResponse(res?.data);
        if (res.status === 200) {
          if (typeof res.data[`${carrier.toLowerCase()}`] === "string") {
            toast.error(`Fedex: ${res.data[`${carrier.toLowerCase()}`]}`);
            toast.error("Please try another shipping carrier at this time");
          }
          if (
            res.data[`${carrier.toLowerCase()}`]?.output?.rateReplyDetails
              ?.length > 0
          ) {
            setLoading(false);
            const dropDownData = res.data[
              `${carrier.toLowerCase()}`
            ]?.output?.rateReplyDetails.map((item) => {
              return {
                price: item.ratedShipmentDetails[0].totalNetFedExCharge,
                serviceType: item.serviceType,
                serviceName: item.serviceName,
                packagingType: item.packagingType,
              };
            });
            setServicesData(dropDownData);
          }
          if (res?.data?.ups?.RateResponse?.RatedShipment?.length > 0) {
            setLoading(false);
            const dropDownData =
              res?.data?.ups?.RateResponse?.RatedShipment?.map((item) => {
                return {
                  price: item.TotalCharges.MonetaryValue,
                  serviceName: upsServiceTypes?.find(
                    (i) => i?.id === item?.Service?.Code
                  )?.name,
                  packagingType: "YOUR PACKAGING",
                  serviceCode: item?.Service?.Code,
                };
              });
            setUpsDropdownData(dropDownData);
          }
          if (res.data?.usps?.length > 0) {
            setLoading(false);
            const dropDownData = res?.data?.usps?.map((item) => {
              return {
                price: item?.shipmentCost,
                serviceName: item?.serviceName,
                packagingType: "YOUR PACKAGING",
                serviceCode: item?.serviceCode,
              };
            });

            setUspsDropdownData(dropDownData);
          }
          setShipping(true);
        } else if (res.status === 400) {
          const errorData = res?.message?.data;
        } else {
          setShipping(false);
          setLoading(false);
          toast.error("Some error occurred");
        }
      });
    } catch (error) {
      setLoading(false);
    }
  };
  async function fetchAndConvertLabel(content) {
    try {
      const base64Data = content;
      if (!base64Data) {
        throw new Error("No label content provided");
      }
      const pdfjsLib = window["pdfjs-dist/build/pdf"];
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        "//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js";
      const pdf = await pdfjsLib.getDocument({ data: atob(base64Data) })
        .promise;
      const page = await pdf.getPage(1);
      const scale = 4;
      const viewport = page.getViewport({ scale });
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      await page.render({ canvasContext: context, viewport }).promise;
      return canvas.toDataURL("image/png").split(",")[1];
    } catch (error) {
      console.error("Error converting FedEx label:", error);
      return null;
    }
  }
  const onPressCreateLabel = async () => {
    let userInfo = {
      username: user?.username ?? "",
      email: user?.email ?? "",
      role: user?.role ?? "",
      profileImage: user?.profileImage ?? "",
      phone: user?.phone ?? "",
      address: user?.address ?? "",
      _id: user?._id ?? "",
    };
    setLabelLoading(true);

    const recipientData = {
      personName: `${orderData?.shipping?.first_name} ${orderData?.shipping?.last_name}`,
      phoneNumber: orderData?.shipping?.phone,
      companyName: orderData?.shipping?.company,
      streetLines: [
        orderData?.shipping?.address_1,
        orderData?.shipping?.address_2,
      ],
      city: orderData?.shipping?.city,
      stateOrProvinceCode: orderData?.shipping?.state,
      postalCode: orderData?.shipping?.postcode,
      countryCode: orderData?.shipping?.country,
    };
    const senderData = {
      personName: `${orderData?.billing?.first_name} ${orderData?.billing?.last_name}`,
      phoneNumber: orderData?.billing?.phone,
      companyName: orderData?.billing?.company,
      streetLines: [
        orderData?.billing?.address_1,
        orderData?.shipping?.address_2,
      ],
      city: orderData?.billing?.city,
      stateOrProvinceCode: orderData?.billing?.state,
      postalCode: orderData?.billing?.postcode,
      countryCode: orderData?.billing?.country,
    };
    const fedexData = {
      recipient: recipientData,
      serviceType: serviceType,
      packagingType: packageType,
      pickupType: "CONTACT_FEDEX_TO_SCHEDULE",
      totalWeight: lbs.toString(),
      customerAccountNumber: account ?? "",
      paymentType: paymentMethod ?? "",
      signatureRequired: signatureRequired ?? false,
    };
    const upsData = {
      recipient: recipientData,
      serviceType: { code: serviceCode, type: serviceType },
      dimensions: {
        totalWeight: lbs.toString(),
        totalLength: length,
        totalWidth: width,
        totalHeight: height,
      },
      customerAccountNumber: account ?? "",
      paymentType: paymentMethod ?? "",
      signatureRequired: signatureRequired ?? false,
    };
    const uspsData = {
      recipient: recipientData,
      serviceType: serviceCode,
      dimensions: {
        totalWeight: lbs.toString(),
        totalLength: length,
        totalWidth: width,
        totalHeight: height,
      },
      customerAccountNumber: account ?? "",
      paymentType: paymentMethod ?? "",
      signatureRequired: signatureRequired ?? false,
    };

    if (returnOrder) {
      fedexData.senderData = senderData;
      upsData.senderData = senderData;
      uspsData.senderData = senderData;
    }
    if (carrier === "FEDEX") {
      const apiToCall = returnOrder
        ? createFedexReturnLabelApi
        : createFedexLabelApi;

      apiToCall(fedexData, async (res) => {
        if (res && res?.status === 200) {
          setLabelLoading(false);
          setShipping(false);

          const content =
            res?.data?.output?.transactionShipments?.[0]?.pieceResponses?.[0]
              ?.packageDocuments?.[0]?.content;
          const url =
            res?.data?.output?.transactionShipments?.[0]?.pieceResponses?.[0]
              ?.packageDocuments?.[0]?.url;
          const fedexTracking =
            res?.data?.output?.transactionShipments?.[0]?.masterTrackingNumber;
          const baseLabel = await fetchAndConvertLabel(content);
          if (url && fedexTracking && baseLabel) {
            const newLabel = {
              labelImage: null,
              trackingData: {
                trackResults: [
                  {
                    shipperInformation: {
                      address: {
                        stateOrProvinceCode: "IL",
                        city: "BOLINGBROOK",
                      },
                    },
                    serviceDetail: { description: fedexData?.serviceType },
                    lastUpdatedDestinationAddress: {
                      stateOrProvinceCode: recipientData?.stateOrProvinceCode,
                    },
                    packageDetails: {
                      weightAndDimensions: {
                        weight: [{ value: fedexData.totalWeight }],
                      },
                    },
                  },
                ],
              },
              type: "fedex",
              trackingNumber: fedexTracking,
              trackingType: "Direct Ship",
            };
            uploadBase64Labels(baseLabel, "fedexImages", "png").then(
              (response) => {
                if (response) {
                  newLabel.labelImage = response;
                  let obj = {
                    _id: uniqueID(),
                    lineItemDetails: selectedRows.map((i) => {
                      return {
                        quantity: i.quantity,
                        price: i.price,
                        _id: i._id,
                        sku: i?.sku,
                      };
                    }),
                    orderId: orderData?._id,
                    labelData: newLabel,
                    createdAt: Date.parse(new Date()),
                    labelType: newLabel?.type,
                    shippingCost: shippingCost,
                    createdBy: userInfo ?? {},
                  };
                  saveData("Trackings", obj?._id, obj)?.then((result) => {
                    if (result) {
                      toggle();
                      if (response) {
                        refreshSaleOrderDetails();
                        window.open(response, "_blank");
                      }
                    }
                  });
                } else {
                  toast.error("Failed to upload FedEx label");
                }
              }
            );
          }
        } else {
          let err = JSON.stringify(res?.message);
          setLabelLoading(false);
          toast.error(err);
        }
      });
    } else if (carrier === "UPS") {
      const apiToCall = returnOrder
        ? createUPSReturnLabelApi
        : createUpsLabelApi;
      apiToCall(upsData, async (res) => {
        if (res && res.status === 200) {
          const baseImage =
            res?.data?.ShipmentResponse?.ShipmentResults?.PackageResults?.[0]
              ?.ShippingLabel?.GraphicImage;
          const trackingNumber =
            res?.data?.ShipmentResponse?.ShipmentResults?.PackageResults?.[0]
              ?.TrackingNumber;
          uploadBase64Labels(baseImage, "upsImages", "gif").then(
            async (response) => {
              if (response) {
                await trackUpsShipmentApi(trackingNumber, (res) => {
                  if (res?.status === 200) {
                    const newLabel = {
                      labelImage: response,
                      trackingData: res?.data,
                      type: "ups",
                      trackingNumber: trackingNumber,
                      trackingType: "Direct Ship",
                    };
                    let obj = {
                      _id: uniqueID(),
                      orderId: orderData?._id,
                      labelData: newLabel,
                      lineItemDetails: selectedRows.map((i) => {
                        return {
                          quantity: i.quantity,
                          price: i.price,
                          _id: i._id,
                          sku: i?.sku,
                        };
                      }),
                      createdAt: Date.parse(new Date()),
                      labelType: newLabel?.type,
                      shippingCost: shippingCost,
                      createdBy: userInfo ?? {},
                    };
                    saveData("Trackings", obj?._id, obj)?.then((result) => {
                      if (result) {
                        toggle();
                        if (response) {
                          refreshSaleOrderDetails();
                          window.open(response, "_blank");
                        }
                      }
                    });
                  } else {
                    toast.error(res?.message);
                    setLabelLoading(false);
                  }
                });
              } else {
                setLabelLoading(false);
                toggle();
                setShipping(false);
              }
            }
          );
        } else {
          let err = JSON.stringify(res?.message);
          setLabelLoading(false);
          toast.error(err);
        }
      });
    } else if (carrier === "USPS") {
      createUspsLabelApi(uspsData, async (res) => {
        if (res && res.status === 200) {
          const label = res?.data?.labelData;
          const trackingNumber = res?.data?.trackingNumber;
          uploadBase64Labels(label, "uspsImages", "pdf").then(
            async (response) => {
              if (response) {
                await trackUspsShipmentApi(trackingNumber, (res) => {
                  if (res?.status === 200) {
                    const newLabel = {
                      labelImage: response,
                      trackingData: res?.data?.shipments?.[0],
                      type: "usps",
                      trackingNumber: trackingNumber,
                      trackingType: "Direct Ship",
                    };
                    let obj = {
                      _id: uniqueID(),
                      orderId: orderData?._id,
                      shippingCost: shippingCost,
                      labelData: newLabel,
                      lineItemDetails: selectedRows.map((i) => {
                        return {
                          quantity: i.quantity,
                          price: i.price,
                          _id: i._id,
                          sku: i?.sku,
                        };
                      }),
                      createdAt: Date.parse(new Date()),
                      labelType: newLabel?.type,
                      createdBy: userInfo ?? {},
                    };
                    saveData("Trackings", obj?._id, obj)?.then((result) => {
                      if (result) {
                        toggle();
                        if (response) {
                          refreshSaleOrderDetails();
                          window.open(response, "_blank");
                        }
                      }
                    });
                  } else {
                    toast.error(res?.message);
                    setLabelLoading(false);
                  }
                });
              } else {
                setLabelLoading(false);
                toggle();
                setShipping(false);
              }
            }
          );
        } else {
          let err = JSON.stringify(res?.message);
          setLabelLoading(false);
          toast.error(err);
        }
      });
    } else {
      setLabelLoading(false);
      toast.error("Try again, some errors occurred");
    }
  };
  const handleModalClose = () => {
    setWidth(0);
    setLength(0);
    setHeight(0);
    setPackageType("");
    setServiceType("");
    setSelectedRows([]);
    setShipping(false);
    setCarrier("FEDEX");
  };
  useEffect(() => {
    if (customer_acc) {
      setAccount(customer_acc);
    }
  }, [customer_acc]);

  return (
    <>
      <SelectServiceCarrierModal
        toggle={toggleModal}
        modal={carrierModal}
        carrier={carrier}
        setCarrier={setCarrier}
        quotesResponse={quotesResponse}
      />
      <Modal
        isOpen={modal}
        toggle={toggle}
        centered
        size="xl"
        onClosed={handleModalClose}
      >
        <ModalBody style={{ padding: "25px" }}>
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3" style={{ borderBottom: "2px solid #e2e8f0", paddingBottom: "12px" }}>
            <div className="d-flex align-items-center gap-2">
              <div className="d-flex flex-column gap-1">
                <div style={{ width: "24px", height: "4px", backgroundColor: "#3b5998", borderRadius: "2px" }} />
                <div style={{ width: "24px", height: "4px", backgroundColor: "#dc2626", borderRadius: "2px" }} />
              </div>
              <h4 className="m-0 fw-bold" style={{ color: "#1a1a2e", letterSpacing: "0.3px" }}>Add Shipping</h4>
              {selectedRows?.length > 0 && (
                <span className="ms-2 px-2 py-1 rounded-pill" style={{ backgroundColor: "#fee2e2", color: "#dc2626", fontSize: "12px", fontWeight: 700 }}>
                  {selectedRows.length} selected
                </span>
              )}
            </div>
            <IoCloseSharp
              size={28}
              onClick={toggle}
              className="pointer"
              style={{ cursor: "pointer", color: "#6b7280" }}
            />
          </div>

          {/* Table Container */}
          <div style={{ borderRadius: "8px", overflow: "hidden", border: "1px solid #e2e8f0", marginBottom: "20px" }}>
            <Table
              responsive
              bordered
              hover
              className="text-center mb-0"
              style={{ fontSize: "13px" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#2d4a7a", color: "#fff" }}>
                  <th style={{ width: "50px", padding: "10px 8px" }}>
                    <Input
                      type="checkbox"
                      style={{ width: "16px", height: "16px", cursor: "pointer" }}
                      onChange={(e) => handleSelectAll(e, items)}
                      checked={selectedRows?.length === items?.length && items?.length > 0}
                    />
                  </th>
                  <th style={{ width: "70px", padding: "10px 8px", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Image</th>
                  <th style={{ width: "120px", padding: "10px 8px", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Sku</th>
                  <th style={{ width: "100px", padding: "10px 8px", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Part</th>
                  <th style={{ width: "90px", padding: "10px 8px", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Price</th>
                  <th style={{ width: "130px", padding: "10px 8px", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Shipping Qty</th>
                  <th style={{ width: "100px", padding: "10px 8px", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Total</th>
                </tr>
              </thead>
              <tbody>
                {lineItems?.map((row, index) => {
                  const isSelected = selectedRows.some((item) => item.sku === row.sku);
                  const currentQty = (isSelected && selectedRows.find((item) => item.sku === row.sku)?.quantity) || row?.quantity;

                  return (
                    <tr
                      key={index}
                      className="align-middle"
                      style={{
                        backgroundColor: isSelected ? "#eef2ff" : index % 2 === 0 ? "#fff" : "#f8fafc",
                        borderLeft: isSelected ? "3px solid #3b5998" : "3px solid transparent",
                        transition: "background-color 0.15s ease",
                      }}
                    >
                      <td style={{ padding: "8px" }}>
                        <Input
                          type="checkbox"
                          style={{ width: "16px", height: "16px", cursor: "pointer" }}
                          onChange={(e) => handleCheckboxChange(e, row)}
                          checked={isSelected}
                        />
                      </td>
                      <td style={{ padding: "8px" }}>
                        <Avatar
                          src={row?.image?.src ?? ""}
                          shape="square"
                          size={36}
                          style={{ border: "1px solid #e2e8f0" }}
                        />
                      </td>
                      <td style={{ fontWeight: 600, color: "#1e293b", padding: "8px" }}>{row.sku}</td>
                      <td style={{ color: "#64748b", padding: "8px" }}>{row?.sku?.slice(4, row?.sku.length) ?? 0}</td>
                      <td style={{ color: "#1e293b", padding: "8px" }}>${row.price}</td>
                      <td style={{ padding: "8px" }}>
                        <div className="d-flex flex-column align-items-center gap-1">

                          <FormInput
                            size="small"
                            type="number"
                            className="w-75 text-center"
                            value={currentQty}
                            handleChange={(e) => handleQuantityChange(e, row?.sku)}
                          />
                        </div>
                      </td>
                      <td style={{ fontWeight: 700, color: "#1e40af", padding: "8px" }}>
                        ${(row?.price * currentQty)?.toFixed(2)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>

          {/* Shipping Configuration Section */}
          <div className="p-4 rounded-3 border bg-white" style={{ border: "1px solid #e2e8f0 !important" }}>
            <div className="d-flex align-items-center gap-2 mb-3">
              <span style={{ fontSize: "12px", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "1px" }}>Destination</span>
              <div className="flex-grow-1" style={{ height: "1px", backgroundColor: "#e2e8f0" }} />
            </div>

            <div className="p-2 mb-3 rounded" style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0" }}>
              <small className="text-primary fw-bold" style={{ fontSize: "13px" }}>
                {shippingData?.address_1 ?? "No shipping address provided"}
              </small>
            </div>

            <div className="d-flex gap-4 mb-4">
              <Checkbox
                name="residential"
                className="fw-semibold text-muted"
                checked={residential}
                onChange={(e) => setResidiential(e.target.checked)}
              >
                Residential Delivery
              </Checkbox>
              <Checkbox
                name="insured"
                className="fw-semibold text-muted"
                checked={insured}
                onChange={(e) => setInsured(e.target.checked)}
              >
                Insured Package
              </Checkbox>
            </div>

            <div className="d-flex align-items-center gap-2 mb-3">
              <span style={{ fontSize: "12px", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "1px" }}>Package Dimensions</span>
              <div className="flex-grow-1" style={{ height: "1px", backgroundColor: "#e2e8f0" }} />
            </div>

            <Row className="g-3 align-items-end">
              <Col md={2}>
                <FormInput
                  label={"Weight (LBS)"}
                  type={"number"}
                  placeholder={"00"}
                  value={lbs}
                  handleChange={(e) => setLbs(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <FormInput
                  label={"Weight (OZ)"}
                  type={"number"}
                  placeholder={"00"}
                  value={oz}
                  handleChange={(e) => setOz(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <FormInput
                  label={"Length (IN)"}
                  type={"number"}
                  placeholder={"00"}
                  value={length}
                  handleChange={(e) => setLength(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <FormInput
                  label={"Width (IN)"}
                  type={"number"}
                  placeholder={"00"}
                  value={width}
                  handleChange={(e) => setWidth(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <FormInput
                  label={"Height (IN)"}
                  type={"number"}
                  placeholder={"00"}
                  value={height}
                  handleChange={(e) => setHeight(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <Button
                  className="w-100 border-0 fw-bold d-flex justify-content-center align-items-center mb-3"
                  style={{
                    backgroundColor: "#3b5998",
                    color: "#fff",
                    height: "35px",
                    fontSize: "13px",
                    borderRadius: "6px",
                    opacity: (loading || selectedRows.length === 0 || !lbs || !height || !length || !width) ? 0.7 : 1
                  }}
                  onClick={onPressCalculate}
                  disabled={loading || selectedRows.length === 0 || !lbs || !height || !length || !width}
                >
                  {loading ? <Spinner size="sm" /> : "Calculate Shipping"}
                </Button>
              </Col>
            </Row>

            {carrier && shipping && (
              <div className="mt-4 pt-4 border-top">
                <div
                  className="d-flex align-items-center gap-2 mb-3 pointer p-2 rounded"
                  style={{ backgroundColor: "#eff6ff", border: "1px dashed #3b5998" }}
                  onClick={toggleModal}
                >
                  <span className="fw-bold" style={{ color: "#3b5998", fontSize: "13px" }}>Selected Carrier: {carrier}</span>
                  <small className="text-muted ms-auto underline">Change Carrier</small>
                </div>

                <Carrier
                  carrier={carrier}
                  account={account}
                  setAccount={setAccount}
                  setShippingCost={setShippingCost}
                  servicesData={
                    carrier === "FEDEX"
                      ? servicesData
                      : carrier === "UPS"
                        ? upsDropdownData
                        : uspsDropdownData
                  }
                  setServiceCode={setServiceCode}
                  setServiceType={setServiceType}
                  setPackageType={setPackageType}
                  onPressCreateLabel={onPressCreateLabel}
                  toggle={toggle}
                  labelLoading={labelLoading}
                  paymentMethod={paymentMethod}
                  setPaymentMethod={setPaymentMethod}
                  signatureRequired={signatureRequired}
                  setSignatureRequired={setSignatureRequired}
                />
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
export default AddShippingModal;
